import React from "react";
import styles from "./styles.module.scss";
import moment from "moment";
import { getDayShortName } from "../../../../common/utils/methods/commonMethods/utilityMethod";
import IconButtonWrapper from "../../../../common/form-fields-mui/IconButtonWrapper";
import { ReactComponent as EditIcon } from "assets/img/svg/Edit2.svg";
import CustomChip from "../../../../common/customChip/CustomChip";

const MissingLectureItem = ({ row, rowChangeHandler, rowIndex }) => {
  return (
    <div className={`${styles["missing-lecture-container"]} my-2`}>
      <div className="timetable-lecture-details-card-row">
        <div>{moment(row?.date)?.format("DD MMM YYYY")}</div>
        <div>{getDayShortName(row?.date)}</div>
        <div>{row?.startTime}</div>
        <div>{row?.endTime}</div>
        <div>{row?.classType}</div>
        <div>{row?.subject || "-"}</div>
        <div>-</div>
        <div>-</div>
        <div>-</div>
        <div>-</div>
        <div>-</div>
        <div>
          <CustomChip textColor="#262626" bgColor="#EEEEEE" text="Inactive" />
        </div>
        <div>
          <IconButtonWrapper
            onClick={() => {
              rowChangeHandler(rowIndex, { ...row, isEdit: true });
            }}
          >
            <EditIcon />
          </IconButtonWrapper>
        </div>
      </div>
    </div>
  );
};

export default MissingLectureItem;
export const MissingLectureContainer = ({ children }) => (
  <div className={styles["missing-lecture-container"]}> {children}</div>
);
